<template>
  <div class="nav" :style="{ '--active-color': packColor }">
    <router-link
      class="item"
      :to="{ name: 'pack-settings-invite', params: { packId: $route.params.packId } }"
    >
      {{ $t('invitationTitle') }}
    </router-link>
    <div class="separator">|</div>
    <router-link
      class="item"
      :to="{ name: 'pack-settings-diploma', params: { packId: $route.params.packId } }"
    >
      {{ $t('diplomaTitle') }}
    </router-link>
    <div class="separator">|</div>
    <router-link
      class="item"
      :to="{ name: 'pack-settings-reminder', params: { packId: $route.params.packId } }"
    >
      {{ $t('reminderTitle') }}
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'LearningSettingsMenu',
  props: {
    theme: {
      type: Object,
      required: false,
      default: null
    }
  },
  computed: {
    packColor () {
      return this.theme ? this.theme.courseColor.hex : '#FFC72E'
    }
  }
}
</script>

<style scoped>
.nav {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px 0 20px;

  & > * {
    margin: 10px;
    font-size: 20px;
  }
}

a {
  color: #cccccc;
  text-decoration: none;

  &.router-link-exact-active {
    color: var(--active-color);
  }
}

.separator {
  color: #cccccc;
}
</style>
